import GsDivider from "./gs-divider.vue"
const component = {
  install: (Vue) => {
    Vue.component('GsDivider', GsDivider)
  }
}
export default component